<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import * as axios from 'axios'

    const ADSTXT_LINE_API_URL = process.env.VUE_APP_API_URL + 'adstxt-line/';
    const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';


/**
 * Create publisher form component
 */
export default {
  page: {
    title: 'Create Site',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: 'Site validation',
      items: [
        {
          text: 'Unblockia',
          href: '/',
        },
        {
          text: 'Create site',
          active: true,
        },
      ],
      tabIndex: 0,
      readyToNext:false,
      domain: '',
      validDomain: '',
      domainSubmitted: false,
      adstxtSubmitted: false,
      domainError:'',
      scriptError:false,
      adstxtError:false,
      siteId: '',
      scriptCode: `&lt;script defer src=&quot;https://cdn.unblockia.com/h.js&quot;&gt;&lt;/script&gt;`,
      adstxtCode: '',
      adstxtArray: [],
      scriptIsCopied: false,
      adstxtIsCopied: false,
      scriptSubmitted: false,
      adstxtIsValidating: false,
      scriptIsValidating: false,
      }

  },
       validations: {
      },
      computed: {
            currentUserId: () => {
                return  JSON.parse(localStorage["auth.currentUser"]).id
            },
            currentUserName: () => {
                return  JSON.parse(localStorage["auth.currentUser"]).name
            }
            
  },
 async mounted() {
    this.getSiteStatus();
    /* get adstxt lines */
    const response = await axios.get(ADSTXT_LINE_API_URL)
    this.adstxtArray = response.data
    this.adstxtCode = response.data.join('\n')
    },
    methods: {
         async getSiteStatus() {
           this.siteId = this.$route.params.siteId
            if(this.siteId){
              const response = await axios.get(DASHBOARD_API_URL + 'sites/' + this.siteId + '/status');
              const siteStatus = response.data;
              if(siteStatus == 1){
                /* need to validate script and ads.txt */
                this.tabIndex = 1
              }
              else if(siteStatus == 2 ) {
                /* need to validate ads.txt */
                this.tabIndex = 2
              }
              else if(siteStatus == 3 ) {
                /* need to wait for whitelisting */
                this.tabIndex = 3
              }
              else {
                /* page not found */
                this.$router.push(`/404`)
              }

            }
         },
         domainValidator (url) {
          const urlRegEx = /^((ftp|http[s]?):\/\/)?(www\.)?([a-z0-9]+)\.[a-z]{2,5}(\.[a-z]{2})?$/;
          const urlHttpRegEx = /^((ftp|http[s]?):\/\/)(www\.)?([a-z0-9]+)\.[a-z]{2,5}(\.[a-z]{2})?$/;
          let newUrl;
          if (urlRegEx.test(url)) {
            if (urlHttpRegEx.test(url)) {
              const httpUrl = new URL(url);
              newUrl= httpUrl.hostname;
            } else {
              newUrl = url;
            }
          }
          const urlWwwRegEx = /(www\.)([a-z0-9]+)\.[a-z]{2,5}(\.[a-z]{2})?$/;
          if(urlWwwRegEx.test(newUrl)){
            newUrl = newUrl.slice(4)
          }
          return newUrl
        },
        async createSite () {
          this.domainSubmitted=true;
          const sitePayLoad = {userId: this.currentUserId, domain: this.validDomain}
          const response = await axios.post(DASHBOARD_API_URL + 'sites', sitePayLoad);
          if(response.data.error){
            this.domainError = response.data.error
          }else{
            this.siteId = response.data.id
            this.$router.push( `/users/${this.currentUserId}/sites/${this.siteId}/validate` )
          }
          

        },
        validateDomain () {
          this.domainSubmitted = false;
          const result = this.domainValidator(this.domain)
          if(result){
            this.validDomain = result;
            this.readyToNext = true;
          }else{
            this.readyToNext = false;
          }
        },
        async validateScript () {
          this.scriptSubmitted = true;
          this.scriptError = false;
          this.scriptIsValidating = true;
          const response = await axios.get(DASHBOARD_API_URL + 'sites/' + this.siteId + '/validate-script')
          if(!response.data){
            this.scriptError = true;
            this.scriptIsValidating = false;
          }else{
            this.scriptError = false;
            this.scriptIsValidating = false;
            this.tabIndex++
          }
          
        },
        async validateAdstxt () {
          this.adstxtSubmitted = true;
          this.adstxtError = false;
          this.adstxtIsValidating = true;
          const response = await axios.get(DASHBOARD_API_URL + 'sites/' + this.siteId + '/validate-adstxt')
          if(!response.data){
            this.adstxtError = true;
            this.adstxtIsValidating = false;

          }else{
            this.adstxtError = false;
            this.adstxtIsValidating = false;
            this.tabIndex++
          }
        },
        unencodeHtmlContent (escapedHtml) {
            const elem = document.createElement('div');
            elem.innerHTML = escapedHtml;
            let result = '';
            for (let i = 0; i < elem.childNodes.length; ++i) {
                result = result + elem.childNodes[i].nodeValue;
            }
            return result;
        },
        copyCode (selector, flag) {
          let CodeToCopy = document.querySelector(selector)
          CodeToCopy.setAttribute('type', 'text')   
          CodeToCopy.select()

          try {
            var successful = document.execCommand('copy');

          } catch (err) {
            console.log('Oops, unable to copy');
          }

          /* unselect the range */
          CodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
          this[flag] = true;
          setTimeout(()=>{
            this[flag] = false
          }, 2000)
        }
        
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
          
        <!-- Tabs & Forms -->
        <div class="card-box height">
          <b-tabs justified nav-class="nav-tabs nav-bordered">
            <b-tab active :disabled="tabIndex !== 0" title-item-class="active-tab">
                <template #title>
                    <span 
                      class="pill active-pill"
                      v-if="tabIndex==0"
                    >
                      1
                    </span>
                    <span 
                      class="pill active-pill"
                      v-if="tabIndex>0"
                    >
                      <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 110 110" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                      <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                        <g>
                          <g id="a">
                            <path d="M88.7,30.6c0-1.6-0.5-3-1.6-4.2c-1.1-1.2-2.5-1.8-4.1-1.8c-1.6,0-3,0.5-4.2,1.7L39.6,64.2L26.8,50
                              c-1.1-1.2-2.4-1.8-4.1-1.9c-1.6-0.1-3,0.4-4.2,1.5c-1.2,1.1-1.8,2.4-1.9,4c-0.1,1.6,0.4,3,1.5,4.3L35,76.6
                              c0.7,0.8,1.6,1.3,2.6,1.6c1,0.3,2,0.4,3.1,0.1c1-0.3,2-0.8,2.7-1.5l43.6-42.2C88.1,33.5,88.7,32.2,88.7,30.6z"/>
                          </g>
                        </g>
                      </g>
                      </svg>                    
                    </span>
                    Create Site
                </template>
                <div class="col-md-6 m-auto vertical-center  flex-column justify-content-center ">
                <div class="form-group">
                  <label>
                    Domain
                  </label>
                  <input
                    v-model="domain"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': domainSubmitted && domainError }"
                    @input="validateDomain"
                    placeholder="Enter your domain"
                  />
                  <div
                    v-if="domainSubmitted && domainError"
                    class="invalid-feedback"
                  >
                    {{domainError}}
                  </div>
                </div>
                  <div class="text-center">
                     <b-button class="mb-2 mt-4 width-sm btn-rounded" variant="primary" :disabled="!readyToNext"  @click="createSite">Create domain</b-button>
                  </div>
                </div>
            </b-tab>
            <b-tab :disabled="tabIndex !== 1" :title-item-class="{ 'active-tab' : tabIndex >= 1}">
                <template #title>
                    <span 
                      class="pill"
                      :class="{ 'active-pill' : tabIndex == 1 }"
                      v-if="tabIndex<=1"
                    >
                      2
                    </span>
                    <span 
                      class="pill active-pill"
                      v-if="tabIndex>1"
                    >
                      <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 110 110" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                      <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                        <g>
                          <g id="a">
                            <path d="M88.7,30.6c0-1.6-0.5-3-1.6-4.2c-1.1-1.2-2.5-1.8-4.1-1.8c-1.6,0-3,0.5-4.2,1.7L39.6,64.2L26.8,50
                              c-1.1-1.2-2.4-1.8-4.1-1.9c-1.6-0.1-3,0.4-4.2,1.5c-1.2,1.1-1.8,2.4-1.9,4c-0.1,1.6,0.4,3,1.5,4.3L35,76.6
                              c0.7,0.8,1.6,1.3,2.6,1.6c1,0.3,2,0.4,3.1,0.1c1-0.3,2-0.8,2.7-1.5l43.6-42.2C88.1,33.5,88.7,32.2,88.7,30.6z"/>
                          </g>
                        </g>
                      </g>
                      </svg>                    
                    </span>
                    Script Embed
                </template>
                <div class="col-lg-9  m-auto">
                  <p class="ml-md-3 dark-text"> Hi {{currentUserName}} ! Thank you for your interest in <strong>Unblockia</strong>. For the first step , you should <strong>embed the Unblockia script</strong> on your website, this script encapsulates functions that can be used to identify if a user has an adblock activated on their browser, and allows Unblockia to provide advertising content that respects the <a href="https://acceptableads.com/privacy-policy/" target="_blank">Acceptable Ads policy</a>. </p>
                  <p class="ml-md-3 dark-text mb-4">To embed script on your site, we provide you <strong>two options</strong> :</p>
                  <div class="col-md-11 m-auto" role="tablist">
                    
                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" role="tab">
                        <h5 class="m-0">
                          <a v-b-toggle.accordion-1 class="text-dark">
                            <i class="mdi mdi-help-circle mr-1 text-primary"></i>
                             Embed script by installing Unblockia WordPress Plugin
                          </a>
                        </h5>
                      </b-card-header>
                      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text> 
                            <p>💡 Only suitable for websites created through wordpress templates.</p> 
                            <p class="ml-md-3">Open the WordPress template of your site, and search for our <strong>Unblockia plugin</strong> to install the script to your site automatically</p>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" role="tab">
                        <h5 class="m-0">
                          <a v-b-toggle.accordion-2 class="text-dark">
                            <i class="mdi mdi-help-circle mr-1 text-primary"></i>
                            Get our script, and manually embed it to your site 
                          </a>
                        </h5>
                      </b-card-header>
                      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body class="white-bg">
                          <b-card-text> 
                            <p> 💡 Suitable for all kinds of websites. </p>
                            <p class="ml-md-3"> Please go to your website and place the snippet code below on the  HTML &lt;head&gt; element or as high on the HTML &lt;body&gt; element as possible :</p> 
                            <p class="clipboard block-center"> 
                              {{unencodeHtmlContent(scriptCode)}}  
                              <b-button class="btn-sm float-right" variant="secondary" @click.stop.prevent="copyCode('#html-code', 'scriptIsCopied')">{{scriptIsCopied? 'Copied!' : 'Copy'}}</b-button> 
                            </p>   
                            <input type="hidden" id="html-code" :value="unencodeHtmlContent(scriptCode)"/>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    
                  </div>
                  <p class="ml-md-3 dark-text mt-4">After adding script to your site, please click the button below to validate your site, and let's continue to the next step! ( Do you have any doubts? <a href="mailto:info@unblockia.com?subject=New User Questions" target="_blank">Contact us</a> )</p>
          
                  <div class="text-center">
                     <b-button class="mb-3 btn-rounded mt-4" variant="primary" @click="validateScript" v-if="!scriptIsValidating">Validate script</b-button>
                     <b-button variant="primary" disabled class="mb-2 mt-4 width-sm btn-rounded" v-if="scriptIsValidating">
                       <b-spinner small></b-spinner>&nbsp;&nbsp;Loading...
                     </b-button>
                     <div
                            class="mb-2 hidden"
                            :class="{'invalid':scriptSubmitted && scriptError }"
                      >
                          Sorry, please add the script above to your site.
                      </div>
                  </div>
                </div>
            </b-tab>
            <b-tab :disabled="tabIndex !== 2" :title-item-class="{ 'active-tab' : tabIndex >= 2}">
                <template #title>
                    <span 
                      class="pill"
                      :class="{ 'active-pill' : tabIndex == 2 }"
                      v-if="tabIndex<=2"
                    >
                      3
                    </span>
                    <span 
                      class="pill active-pill"
                      v-if="tabIndex>2"
                    >
                      <svg class="done-icon" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 110 110" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                      <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                        <g>
                          <g id="a">
                            <path d="M88.7,30.6c0-1.6-0.5-3-1.6-4.2c-1.1-1.2-2.5-1.8-4.1-1.8c-1.6,0-3,0.5-4.2,1.7L39.6,64.2L26.8,50
                              c-1.1-1.2-2.4-1.8-4.1-1.9c-1.6-0.1-3,0.4-4.2,1.5c-1.2,1.1-1.8,2.4-1.9,4c-0.1,1.6,0.4,3,1.5,4.3L35,76.6
                              c0.7,0.8,1.6,1.3,2.6,1.6c1,0.3,2,0.4,3.1,0.1c1-0.3,2-0.8,2.7-1.5l43.6-42.2C88.1,33.5,88.7,32.2,88.7,30.6z"/>
                          </g>
                        </g>
                      </g>
                      </svg>                    
                    </span>
                    Add ads.txt
                </template>
                <div class="col-lg-9  m-auto">
                  <p class="ml-md-3 dark-text mt-4"> You've finished the Script Embed step {{currentUserName}}🤩, we are almost there! For the second step, you should <strong>add our ads.txt text lines</strong> to your website. For the purpose of preventing unauthorized inventory sales, adding ads.txt text lines will authorize us to sell the inventory/traffic as an authorised digital sellers (ADS), and give the online buyers more confindence in the ads they purchase.</p> 
                  <p class="ml-md-3 dark-text mb-4">Please copy the Unblockia ads.txt text lines below, go to your website again and paste it to the ads.txt file of your website : </p>
                  <b-card class="gray-bg col-lg-9 m-auto ads-container">
                      <p class="mt-4">
                        ⚠️⚠️⚠️need the first line <br>
                        <span 
                        v-for="line in adstxtArray"
                        :key="line.id"
                        >
                        {{line}}
                        <br>
                        </span>
                      </p>
                       
                      <b-button class="btn-sm btn-float" variant="secondary" @click.stop.prevent="copyCode('#ads-code', 'adstxtIsCopied')">{{adstxtIsCopied? 'Copied!' : 'Copy'}}</b-button> 
                  </b-card>
                  <textarea class="hidden-textarea" id="ads-code" :value="unencodeHtmlContent(adstxtCode)"/>
                  <p class="ml-md-3 dark-text mt-3">After adding ads.txt lines to your site, please click the button below to validate your site again and finish this process. ( Do you have any doubts? <a href="mailto:info@unblockia.com?subject=New User Questions" target="_blank">Contact us</a> )</p>
                  <div class="text-center">
                     <b-button class="mb-2 mt-4 width-sm btn-rounded" variant="primary" @click="validateAdstxt" v-if="!adstxtIsValidating">Validate ads.txt</b-button>
                     <b-button variant="primary" disabled class="mb-2 mt-4 width-sm btn-rounded" v-if="adstxtIsValidating">
                       <b-spinner small></b-spinner>&nbsp;&nbsp;Loading...
                     </b-button>
                     <div
                            class="mb-2 hidden"
                            :class="{'invalid':adstxtSubmitted && adstxtError }"
                      >
                          Sorry, please add the ads.txtx lines above to your site.
                      </div>
                  </div>
                </div>
                
            </b-tab>
          </b-tabs>
          <div v-if="tabIndex == 3">
            <div class="m-auto text-center col-md-8">
              <p class="congrats">Congratulations!</p>
              <p class="">You've succesfully created and validated your site on Unblockia. <br> We will whitelist your site and contact with you as soon as possible!</p> 
              <img class="resting-girl" src="@assets/images/resting-girl.png" alt="">
            </div>
            
          </div>
        </div>

    </Layout>
</template>

<style lang="scss">
.pill{
    display: inline-block;
    background-color: white;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    color: #6c757d;
    box-shadow: 1px 1px 3px #adb5bd;
    margin-right: 2px;
}
.active-pill{
    background-color: #6658dd;
    box-shadow: none;
    color: white
}
svg,
.done-icon{
  transform: scale(0.8) translate(1px,-1px);
  path{
    fill: white;
  }
}


.active-tab>a.nav-link{
  border-bottom:2px solid #6658dd !important
}

.white-bg{
  background-color: #ffffff;
}
.gray-bg{
  background-color: #edeff1;
}
.dark-text{
  color:black;
  font-size: 1.05rem;
  font-weight: 200;
  strong {
    font-weight: 700;
  }
}
.clipboard{
  background-color: rgb(244, 244, 244);
  padding: 1.5rem 5%;
}
.hidden-textarea{
  height:0;
  opacity:0;
}
.btn-float{
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.6rem
}
.invalid{
    color:#6658dd;
    font-size:0.75rem;
    opacity: 1 !important;
}
.congrats{
  font-size: 2rem;
  color:#24bc66;
  font-weight: 700;
  margin-top: 20px;
}
.height{
  min-height: 70vh;
}
.hidden{
  opacity: 0;
}
.vertical-center{
  height: 50vh;
    vertical-align: middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.resting-girl{
  margin-bottom: 60px;
}

</style>
